/*
  Вкладка «Полоски» на «Отчётах»: две полосы, выбранные владельцем 29.09.2026.

  Первая - «Весь портфель: где лежат деньги», та же, что стоит на первом экране.
  Вторая - «Сколько осталось времени», полоса сроков давности: она была на выбор
  для дашборда и уехала сюда, потому что первому экрану довольно одного ответа.

  🔴 Обе рисует `PortfolioBar` - тот же компонент, что на дашборде. Своей
  арифметики здесь нет: доли считаются от суммы показанных сегментов, и каждый
  сегмент ведёт в реестр тем же отбором, что плашка над ним.

  Полоса портфеля берёт числа у дашборда, а не считает их заново: это ровно те
  величины, что показывает первый экран, и второй их расчёт означал бы два
  ответа на вопрос «сколько денег взыскивать имеет смысл».
*/

import { accounts as accountsWord, money } from '../api/format.js'
import { Loading } from './Common.jsx'
import PortfolioBar from './PortfolioBar.jsx'
import { limitationSegments, portfolioSegments } from './portfolioSegments.js'

export default function PortfolioBars({ dashboard, detail }) {
  if (!dashboard) return <Loading what="Считаем портфель" />

  return (
    <>
      <PortfolioBar
        segments={portfolioSegments(dashboard)}
        title="Весь портфель: где лежат деньги"
        note="Нажмите на сегмент или на строку под ним - откроется реестр с теми же счетами. Срез на сегодня: период на эту полосу не действует."
      />

      <PortfolioBar
        segments={limitationSegments(detail.limitation)}
        title="Сколько осталось времени"
        note={
          Number(detail.expired_amount) > 0
            ? `Полоса делит цену требования - то, что ещё можно взыскать. Отдельно от неё на сегодня уже сгорело ${money(detail.expired_amount)} по ${accountsWord(detail.expired_accounts)}: этих денег в требовании нет вовсе, вернуть их нельзя ничем. В эту сумму входит и то, что сгорело до подключения Арбитра ЖКХ, - оно показано отдельной плиткой на вкладке «Плашки».`
            : 'Полоса делит цену требования - то, что ещё можно взыскать. Сгоревших денег в портфеле нет.'
        }
      />
    </>
  )
}
